export enum QueryKey {
  AvailableFields = 'availableFields',
  accountUsageSources = 'accountUsageSources',
  mappingPreview = 'mappingPreview',
  sourceTypeList = 'sourceTypeList',
  enhancedAggProjs = 'enhancedAggProjs',
  globalScripts = 'globalScripts',
  outegrationsTicketsDropdown = 'outegrations_tickets_dropdown',
  relations = 'relations',
  account = 'account',
  recommendationSettings = 'recommendationSettings',
  UserAdditionalInfo = 'userAdditionalInfo',
  FeatureFlags = 'featureFlags',
  UiConfig = 'ui_config',
  Entities = 'entities',
  FieldVisibility = 'FieldVisibility',
  DefaultUiConfig = 'default_ui_config',
  UseUiConfigByProjectionName = 'useUiConfigByProjectionName',
  AccessToken = 'access_token',
  UsersInfo = 'usersInfo',
  UsersInfoByEmail = 'usersInfoByEmail',
  FindAllApps = 'findAllApps',
  MitreList = 'mitre-list',
  FindAccountDatastoresMapping = 'findAccountDatastoresMapping',
  GetAvailableServiceNames = 'getAvailableServiceNames',
  GetAvailableDatastoreCategories = 'getAvailableDatastoreCategories',
  SamlDetails = 'saml-details',
  FindAccountById = 'findAccountById',
  Gateways = 'gateways',
  AccountLimits = 'accountLimits',
  AccountUsage = 'accountUsage',
  AccountAliases = 'account-aliases',
  AuthenticationSourceListByType = 'authenticationSourceListByType',
  FindAllAccounts = 'findAllAccounts',
  FindMainAccountsByProvider = 'findMainAccountsByProvider',
  UpdateCustomerAuthProvider = 'updateCustomerAuthProvider',
  FindAllAccountsPagination = 'findAllAccountsPagination',
  findAllAccountsOld = 'findAllAccountsOld',
  FindAllDashboardAccessRoles = 'findAllDashboardAccessRoles',
  FindAllUsers = 'findAllUsers',
  FindAllUsersPagination = 'findAllUsersPagination',
  FindAllEtlMonitors = 'findAllEtlMonitors',
  FindAllRisk360Accounts = 'findAllRisk360Accounts',
  RunOLTPQuery = 'runOLTPQuery',
  ContentPermissions = 'content-permissions',
  CustomDashboardsList = 'customDashboardsList',
  FindDashboardById = 'findDashboardById',
  ExportDashboard = 'exportDashboard',
  CustomRolesList = 'customRolesList',
  FindCustomRoleById = 'findCustomRoleById',
  RetentionRules = 'RetentionRules',
  UnificationRules = 'unificationRules',
  UnificationsRulesSet = 'unificationsRulesSet',
  UnificationPreview = 'unificationPreview',
  PreviewEvaluation = 'previewEvaluation',
  GlobalQueries = 'global-queries',
  FindRiskFactorExecutionRulesByAccountId = 'findRiskFactorExecutionRulesByAccountId',
  FindBuiltInExecutionRulesByType = 'findBuiltInExecutionRulesByType',
  FindRiskFactorExecutionRuleById = 'findRiskFactorExecutionRuleById',
  FindBuiltInExecutionRuleById = 'findBuiltInExecutionRuleById',
  SourceTypes = 'sourceTypes',
  ExecutionGroupId = 'ExecutionGroupId',
  GETFORMATTINGRULES = 'GET_FORMATTING_RULES',
  FindGlobalScriptById = 'findGlobalScriptById',
  SourcesListLogsQuery = 'sourcesListLogsQuery',
  AccountFacets = 'account_facets',
  SourcesListFacets = 'sourcesListFacets',
  GETSOURCESLIST = 'GET_SOURCES_LIST',
  LogsQueries = 'logsQueries',
  LogsQueriesCategory = 'logsQueriesCategory',
  LookupTables = 'LookupTables',
  FieldRegulations = 'fieldRegulations',
  ProjEvaluations = 'projEvaluations',
  ModelPreview = 'model-preview',
  IntegrationLogsFilters = 'integration_logs_filters',
  GetActivityLogs = 'getActivityLogs',
  ContextByIntegration = 'contextByIntegration',
  Outegrations = 'NotificationTargets',
  SchemaByConfigAndDefaultMapping = 'schemaByConfigAndDefaultMapping',
  Policies = 'policies',
  PolicyId = 'policy_id',
  PolicyScenarioFilter = 'policy_scenario_filter',
  ReportData = 'report_data',
  AvailableIntegrationInstance = 'availableIntegrationInstance',
  RuleData = 'rule_data',
  RulesLogs = 'rulesLogs',
  RulesLogsFilters = 'rulesLogsFilters',
  FindRuleById = 'findRuleById',
  GetIntellisense = 'getIntellisense',
  FindRuleByAccountId = 'findRuleByAccountId',
  GroupingRules = 'groupingRules',
  SeverityScoring = 'severityScoring',
  SeveritySettings = 'severitySettings',
  SeveritySla = 'severity-sla',
  AggProjections = 'aggProjections',
  EditSource = 'editSource',
  ConnectorData = 'connector_data',
  DataPreview = 'data-preview',
  SourceMappingId = 'sourceMappingId',
  FileParser = 'fileParser',
  DataPreviewFromWizard = 'data-preview-from-wizard',
  UseDataStreamInstancePreviewSource = 'use-data-stream-instance-preview-source',
  TicketInfo = 'ticket-info',
  TabTable = 'tab-table',
  Views = 'views',
  GetUserRoles = 'getUserRoles',
  GetUsers = 'getUsers',
  GetUsersListNames = 'getUsersListNames',
  FindUserById = 'findUserById',
  FindUserByIdWithEditAccountPermissions = 'findUserByIdWithEditAccountPermissions',
  GetAllowedEditUsersUserAccount = 'getAllowedEditUsersUserAccount',
  GetAllCustomerAccountsByProvider = 'getAllCustomerAccountsByProvider',
  GetAllowedAccountsWithEditAccountPermissions = 'getAllowedAccountsWithEditAccountPermissions',
  GetAccountsWithPermissionOnResource = 'getAccountsWithPermissionOnResource',
  Workflows = 'workflows',
  Mapping = 'mapping',
  DefaultMapping = 'default-mapping',
  UseDataStreamInstancePreview = 'useDataStreamInstancePreview',
  AuthenticationSourceList = 'AuthenticationSourceList',
  AuthenticationSource = 'AuthenticationSource',
  Integration = 'integration',
  Bridge = 'bridge',
  AQLFunctionDocs = 'aql-function-docs',
  FieldsOverrideList = 'FieldsOverrideList',
  getDsiWorkflows = 'getDsiWorkflows',
  getDsiWorkflowsWithMetadata = 'getDsiWorkflowsWithMetadata',
  ExceptionsSettings = 'exceptionSettings',
  ExceptionsSettingsFormDetails = 'exceptionSettingsFormDetails',
  ExceptionReviewers = 'exceptionReviewers',
  defaultRunsQueryKey = 'defaultRunsQueryKey',
  discoverySettings = 'discoverySettings',
  factorRunsQuery = 'factorRunsQuery',
  policyRunsQuery = 'policyRunsQuery',
  reportRunsQuery = 'reportRunsQuery',
  ruleRunsQuery = 'ruleRunsQuery',
  modelManagementRunsQuery = 'modelManagementRunsQuery',
  builtinExecutionRulesRunsQuery = 'builtinExecutionRulesRunsQuery',
  dataRetentionRunsQuery = 'dataRetentionRunsQuery',
  QueryObjectAsync = 'query-object-async',
  AsyncPollDwQuery = 'async-poll-dw-query',
  getApiScopes = 'getApiScopes',
  getScoring = 'getScoring',
  GetIndexTables = 'get-index-tables',
  GetAutomationRules = 'getAutomationsForCategoryAndProjection',
  PreviewBulkIntegration = 'previewBulkIntegration',
  GetAutomationSyncStatus = 'getAutomationSyncStatus',
  ScannerActivations = 'scanner-activation',
  ScannerActivationId = 'scanner-id',
  ScannerActivationSensorId = 'scanner-sensor-id',
  GetViewProjections = 'get-view-projections',
  PaginatedSearchLogs = 'paginated-search-logs',
  DsiDataWFId = 'dsiDataWFId',
  Copilot = 'Copilot',
  InitChatbotSession = 'initChatbotSession',
  GetChatbotMessage = 'getChatbotMessage',
  PublishChatbotMessage = 'publishChatbotMessage',
  GenerateChatbotSummary = 'generateChatbotSummary',
  SaveChatbotSummary = 'saveChatbotSummary',
  EndChatbotSession = 'endChatbotSession',
  GetAutomationRulesDefaults = 'getAutomationRulesDefaults',
  SuggestMapping = 'suggestMapping',
  MappingAgent = 'triggerMappingAgentWorkflow',
  Activities = 'activities',
  ProcessStatus = 'process_status',
  GetAuditLogs = 'getAuditLogs',
  GetAuditLogsAll = 'getAuditLogsAll',
  GetLastClusteringTime = 'getLastClusteringTime',
  DsiEnrich = 'dsi_enrich',
  SourcesManagement = 'sourcesManagement',
  ExportToCsv = 'exportToCsv',
  PolicyCategoryBuiltInFilter = 'policyCategoryBuiltInFilter',
  DeleteAutomation = 'deleteAutomation',
  FieldSyncToSettingByNameAndType = 'field-sync-to-setting-by-name-and-type',
  FieldSyncToSettingType = 'field-sync-to-setting-type',
  IngestFileForAnalytics = 'ingestFileForAnalytics',
  MappingAnalyticsWorkflow = 'mappingAnalyticsWorkflow',
  StatusSwimlaneInfo = 'status-swimlane-info',
  ZidAccountSync = 'zid-account-sync',
  GetScoringAuditLogs = 'getScoringAuditLogs',
  GetExportableEntityTypes = 'getExportableEntityTypes',
  ScorePreview = 'scorePreview',
  AgingRuleSet = 'agingRuleSet',
  ScheduleExportReportPermissions = 'scheduleExportReportPermissions',
  ValidateFieldMapping = 'validateFieldMapping',
  SeveritySettingsDefaults = 'SeveritySettingsDefaults',
  SlaSettingsDefaults = 'SlsSettingsDefaults',
  SlaSettings = 'SlaSettings',
  GetMetricsClickThroughSupport = 'getMetricsClickThroughSupport',
  IsEasmConfigured = 'isEasmConfigured',
  ValidateCsv = 'validateCsv',
  ZscalerCustomerConfig = 'zscalerCustomerConfig',
  ReportPermissions = 'ReportPermissions',
  MeasurementsAndCalculatedDimensions = 'measurementsAndCalculatedDimensions',
}
